import {
  auditsPanelMobileHeight,
  LEFT_SIDE_PANEL_MOTION_MS,
  leftSidePanelMotionEase,
  logRes1,
  mobileRes2,
  topBarColor2,
} from 'pages/styles';
import styled from 'styled-components';

export const scrollBarRes = '1150px';
export const Container = styled.div`
  width: 100%;
  display: flex;
  height: 100%;
  z-index: 1;
  @media(max-width: ${logRes1}) {
    flex-direction: column;
  }
`;

export const AuditsPanelMobile = styled.div<{ $hidden?: boolean }>`
  display: none;
  width: 100%;
  height: ${auditsPanelMobileHeight};
  box-shadow: 0px -1px 2px 2px rgba(0,0,0,0.17);
  -webkit-box-shadow: 0px -1px 2px 2px rgba(0,0,0,0.17);
  -moz-box-shadow: 0px -1px 2px 2px rgba(0,0,0,0.17);
  position: sticky;
  top: 0;
  z-index: 15;
  background: white;
  padding: 13px 19px;
  padding-right: 16px;
  overflow: hidden;
  transition:
    height ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
    padding ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
    opacity 220ms ${leftSidePanelMotionEase},
    box-shadow ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase};
  ${({ $hidden }) => ($hidden ? `
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    opacity: 0;
    pointer-events: none;
    box-shadow: none;
  ` : '')}
  @media(max-width: ${logRes1}) {
    display: flex;
    align-items: flex-end;
    font-weight: 500;
  }
  @media(max-width: ${mobileRes2}) {
    box-shadow: ${({ $hidden }) => ($hidden
    ? 'none'
    : '0px -1px 2px 2px rgba(0,0,0,0.37)')};
    -webkit-box-shadow: ${({ $hidden }) => ($hidden
    ? 'none'
    : '0px -1px 2px 2px rgba(0,0,0,0.37)')};
    -moz-box-shadow: ${({ $hidden }) => ($hidden
    ? 'none'
    : '0px -1px 2px 2px rgba(0,0,0,0.37)')};
    padding: ${({ $hidden }) => ($hidden ? '0 14px' : '13px 14px')};
    padding-right: ${({ $hidden }) => ($hidden ? '13px' : '13px')};
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const AuditsText = styled.div`
  font-weight: 700;
  font-size: 15px;
  color: ${topBarColor2};
  transform: translateY(1.5px);
`;
